export default "__VITE_PUBLIC_ASSET__756868a7__"